import { ensureAnonymousAuth } from "../auth/anonymousAuth";
import { getAnalyticsRequestMetadata } from "../Analytics";
import { resolveActiveFunctionUrl } from "../../configs/runtimeEnvironment";

function resolvePublishCardToWallUrl() {
  return resolveActiveFunctionUrl("publishLettuceTalkCardToWall", {
    devUrl: process.env.REACT_APP_PUBLISH_LETTUCE_TALK_CARD_TO_WALL_URL_DEV,
    prodUrl: process.env.REACT_APP_PUBLISH_LETTUCE_TALK_CARD_TO_WALL_URL_PROD,
    devFallbackUrls: [process.env.REACT_APP_CREATE_LETTUCE_TALK_CARDS_URL_DEV],
    prodFallbackUrls: [process.env.REACT_APP_CREATE_LETTUCE_TALK_CARDS_URL_PROD],
  });
}

export async function publishLettuceTalkCardToWall({ cardId, wallId }) {
  const url = resolvePublishCardToWallUrl();

  const user = await ensureAnonymousAuth();
  const idToken = await user.getIdToken();

  if (!url) {
    throw new Error("Missing publish card to wall function URL");
  }

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify({
      cardId,
      wallId,
      ...getAnalyticsRequestMetadata(),
    }),
    mode: "cors",
  });
  const data = await response.json();

  if (!response.ok) {
    const error = new Error(data.error || "Failed to publish card to wall");
    error.status = response.status;
    error.details = data.details || "";
    throw error;
  }

  return data;
}
